import { render, staticRenderFns } from "./MapModeButton.vue?vue&type=template&id=489c62bb&lang=pug&"
import script from "./MapModeButton.vue?vue&type=script&lang=js&"
export * from "./MapModeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapModeButton.vue"
export default component.exports